// ElectionActualBars — per-fund paired bars comparing election % (where new
// money is directed) vs actual % (where money sits), with a drift pill and the
// per-paycheck dollar amount. Screen-specific to Investment Directions; the
// reusable SegBar is a single STACKED bar, which doesn't fit a paired compare.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cx } from '../../../utils/cx';
import { formatCurrency, formatPercent } from '../../../utils/format';

export function ElectionActualBars({ allocations }) {
  const { t } = useTranslation();
  return (
    <div className="ma-dir-table">
      {allocations.map((a) => {
        const drift = a.actual - a.election;
        const driftTone = drift === 0 ? 'flat' : drift > 0 ? 'pos' : 'neg';
        return (
          <div key={a.ticker} className="ma-dir-row">
            <div className="ma-dir-id">
              <span className="ma-fund-dot" style={{ background: a.color }} aria-hidden="true" />
              <div className="ma-dir-id-txt">
                <div className="ma-fund-ticker">{a.ticker}</div>
                <div className="ma-fund-name">{a.name}</div>
              </div>
            </div>
            <div className="ma-dir-bars">
              <div className="ma-dir-bar-row">
                <span className="ma-dir-bar-lbl">{t('manage.directions.election')}</span>
                <div className="ma-dir-bar">
                  <span style={{ width: `${a.election}%`, background: a.color }} />
                </div>
                <span className="ma-dir-bar-val">{a.election}%</span>
              </div>
              <div className="ma-dir-bar-row">
                <span className="ma-dir-bar-lbl">{t('manage.directions.actual')}</span>
                <div className="ma-dir-bar">
                  <span style={{ width: `${a.actual}%`, background: a.color, opacity: 0.55 }} />
                </div>
                <span className="ma-dir-bar-val">{a.actual}%</span>
              </div>
            </div>
            <div className={cx('ma-drift-pill', driftTone)}>
              {drift === 0 ? '0%' : formatPercent(drift, { digits: 0, signed: true })}
              <span className="ma-drift-sub">{t('manage.lineup.drift')}</span>
            </div>
            <div className="ma-dir-dollar">
              {formatCurrency(a.electDollar)}
              <span className="ma-dir-dollar-sub">{t('manage.lineup.perPaycheck')}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

ElectionActualBars.propTypes = {
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      ticker: PropTypes.string,
      name: PropTypes.string,
      election: PropTypes.number,
      actual: PropTypes.number,
      electDollar: PropTypes.number,
      color: PropTypes.string,
    }),
  ).isRequired,
};

export default ElectionActualBars;
